import { createStore } from 'owa-satcheljs';
import type { ActionButtonState, ActionButtonStateByMailboxInfo } from './schema/ActionButtonState';
import type { AccountKey } from 'owa-client-types';

const followButtonStore: () => ActionButtonStateByMailboxInfo =
    createStore<ActionButtonStateByMailboxInfo>('followButtonStore', {
        groupActionStateByMailboxInfo: new Map<AccountKey, ActionButtonState>(),
    });

export default followButtonStore;
